import React from 'react';
import PropTypes from 'prop-types';

const CloseButton = ({ onClick }) => (
    <button type="button" onClick={onClick} className='dashboard-close-button'>
        &#x2715;
    </button>
);

CloseButton.propTypes = {
    onClick: PropTypes.func.isRequired,
};

export default CloseButton;
